import { Stack, Typography, useTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';

/** Full theme tokens — same visual as profile `FormCreator` (subtitleBold label + subtitle value). */
export const getDetailsModalFieldLabelSx = (theme: Theme) => ({
	...theme.typography.subtitleBold,
	color: theme.palette.text.primary,
});

export const getDetailsModalFieldValueSx = (theme: Theme) => ({
	...theme.typography.subtitle,
	color: theme.palette.text.primary,
});

type Props = {
	label: string;
	value: any;
	/** Break long strings (ids, paths) without layout overflow. */
	breakAll?: boolean;
};

/**
 * Label above value: bold `subtitleBold` + regular `subtitle`, both `text.primary` (profile field stacks).
 */
export const DetailsLabelValue = ({ label, value, breakAll }: Props) => {
	const theme = useTheme();
	if (value === null || value === undefined || value === '') {
		return null;
	}

	const labelSx = getDetailsModalFieldLabelSx(theme);
	const valueBaseSx = getDetailsModalFieldValueSx(theme);

	return (
		<Stack spacing={0.5} sx={{ WebkitFontSmoothing: 'antialiased' }}>
			<Typography component="span" sx={labelSx}>
				{label}
			</Typography>
			<Typography
				component="span"
				sx={{
					...valueBaseSx,
					...(breakAll ? { wordBreak: 'break-all' as const, overflowWrap: 'anywhere' as const } : null),
					...(typeof value === 'number' ? { fontVariantNumeric: 'tabular-nums' } : null),
				}}
			>
				{String(value)}
			</Typography>
		</Stack>
	);
};
